import { render, staticRenderFns } from "./uploadIcon.vue?vue&type=template&id=f195dd42&scoped=true&"
import script from "./uploadIcon.vue?vue&type=script&lang=js&"
export * from "./uploadIcon.vue?vue&type=script&lang=js&"
import style0 from "./uploadIcon.vue?vue&type=style&index=0&id=f195dd42&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f195dd42",
  null
  
)

export default component.exports